import { Layout } from 'antd'
import React, { FC, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { getPublicEnv } from '@tucan/utils'

const Page = styled(Layout)<{ $background: string }>`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  justify-content: center;
  min-height: 100vh !important;
  padding-bottom: 30px;
  padding-top: 30px;
  width: 100vw;
  
  ${props => props.$background && css`
    background-image: url(${props.$background});
    background-size: cover;
  `}
`

interface Props {
  children: ReactNode
  footer?: boolean
}

export const PageCenter: FC<Props> = (props) => {
  return (
    <Page
      $background={getPublicEnv('BACKGROUND_URL')}
    >
      {props.children}
    </Page>
  )
}
